import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { styled, alpha } from '@mui/material/styles';
import GoogleIcon from '@mui/icons-material/Google';
import { LoginForm } from '../../components/auth';
import { AuthLayout } from '../../components/layouts';
import { Button } from '../../components/ui';

const OrDivider = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  margin: theme.spacing(3, 0),
  '& .MuiDivider-root': {
    flex: 1,
    borderColor: theme.palette.surface.glassBorder,
  },
}));

const DividerText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.75rem',
  fontWeight: 600,
  fontFamily: '"IBM Plex Mono", monospace',
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
}));

const GoogleButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderColor: theme.palette.surface.glassBorder,
  color: theme.palette.text.primary,
  '&:hover': {
    backgroundColor: theme.palette.background.default,
    borderColor: alpha(theme.palette.text.primary, 0.2),
  },
  '& .MuiButton-startIcon': {
    marginRight: theme.spacing(1.5),
    '& svg': {
      color: '#4285F4',
    },
  },
}));

const ForgotPasswordLink = styled(Link)(({ theme }) => ({
  display: 'block',
  textAlign: 'center',
  marginTop: theme.spacing(2),
  color: theme.palette.text.secondary,
  fontSize: '0.875rem',
  fontFamily: '"IBM Plex Sans", sans-serif',
  textDecoration: 'none',
  transition: 'color 0.2s',
  '&:hover': {
    color: theme.palette.success.main,
  },
}));

export function LoginPage() {
  const googleOAuthUrl = `${import.meta.env.VITE_API_URL}/auth/google`;

  return (
    <AuthLayout
      title="Welcome back"
      subtitle={
        <>
          Don't have an account?{' '}
          <Link to="/register">Sign up</Link>
        </>
      }
    >
      <LoginForm />

      <OrDivider>
        <Divider />
        <DividerText>or continue with</DividerText>
        <Divider />
      </OrDivider>

      <GoogleButton
        component="a"
        href={googleOAuthUrl}
        variant="outline"
        fullWidth
        startIcon={<GoogleIcon />}
      >
        Sign in with Google
      </GoogleButton>

      <ForgotPasswordLink to="/forgot-password">
        Forgot your password?
      </ForgotPasswordLink>
    </AuthLayout>
  );
}
